var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"effect":"dark","content":_vm.data.customerGroupTitle,"placement":"top-start"}},[(_vm.data.customerGroup.length)?_c('el-row',_vm._l((this.data.customerGroup),function(item,index){return _c('el-col',{key:item + index},[_c('span',{staticClass:"defaultMailbox"},[_vm._v(_vm._s(item))])])}),1):_c('div',[_vm._v("-")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }